export class KeyValuePair<T,K>{
    key: T;
    value: K;
}